import React from "react";
import { useGLTF } from "@react-three/drei";

export default function Rombek({ material, colors, ...props }) {
  const { nodes, materials } = useGLTF("/models/rombek/rombek.glb");

  const mat = material ?? materials["Dark metal"];
  if (colors) {
    mat.color.set(colors.roof_color.hexa);
  }



  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.dachowka.geometry}
        material={mat}
        frustumCulled={false}
      />
    </group>
  );
}

useGLTF.preload("/models/rombek/rombek.glb");
